<template>
  <v-container fluid class="tp-page">
    <template v-if="!addUser">
      <!-- Cabeçalho -->
      <div class="tp-page-head">
        <div>
          <h1 class="tp-page-title">Divulgadores</h1>
          <p class="tp-page-sub">{{ tabela.conteudo.length }} {{ tabela.conteudo.length === 1 ? 'divulgador' : 'divulgadores' }} no total</p>
        </div>
        <div class="tp-head-actions">
          <v-text-field v-model="tabela.busca" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
          <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="criarNovo">
            <v-icon left>mdi-plus-circle-outline</v-icon>Cadastrar
          </v-btn>
        </div>
      </div>

      <!-- Seletor de Evento -->
      <v-row>
        <v-col cols="12" sm="12" md="6">
          <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" label="Selecione o Evento" @input="carregaDados()" color="#00695C"></v-select>
        </v-col>
      </v-row>

      <!-- Tabela -->
      <v-card class="tp-card" elevation="0">
        <v-data-table :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-3" color="#00695C" @click="editItem(item)">edit</v-icon>
            <v-icon small color="error" @click="deleteItem(item)">delete</v-icon>
          </template>
          <template v-slot:[`item.id`]="{ item }">
            <td>https://aipass.intelite.com.br/{{companyobj.linkVendas}}?d={{item.id}}</td>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <v-icon v-if="item.ativo == true" color="success">circle</v-icon>
            <v-icon v-else color="error">circle</v-icon>
          </template>
          <template v-slot:no-data>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhum divulgador encontrado</v-alert>
          </template>
          <template slot="no-results">
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <!-- CARD INSERE USUARIOS -->
    <v-card v-else class="tp-card tp-form" elevation="0">
      <template v-if="adicionarDivulgador">
        <v-card-title>
          <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:13px; color:#00695C; margin:0"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#00695C"></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model="editedItem.cpf" outlined label="CPF" color="#00695C" v-mask="'###.###.###-##'" type="tel"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model="editedItem.email" outlined label="E-mail" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model="editedItem.celular" outlined label="WhatsApp com DDD" color="#00695C" type="tel" v-mask="'(##) #####-####'"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-switch v-model="editedItem.ativo" label="Ativo" color="#00695C" hide-details></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="#00695C" text large @click="close">Cancelar</v-btn>
          <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click="save">Salvar</v-btn>
        </v-card-actions>
      </template>
    </v-card>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      addUser: false,
      adicionarDivulgador: false,
      temInscritos: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'CPF', value: 'cpf' },
          { text: 'E-mail', value: 'email' },
          { text: 'Link', value: 'id' },
          { text: 'Ativo', value: 'ativo' },
          { text: 'Ações', value: 'action', align: 'center', sortable: false },
        ],
        conteudo: []
      },
      editedIndex: -1,
      editedItem: {
        nome: '',
        cpf: '',
        email: '',
        celular: '',
        ativo: null,
        empresaId: '',
        eventoId: '',
      },
      defaultItem: {
        nome: '',
        cpf: '',
        email: '',
        celular: '',
        ativo: null,
        empresaId: '',
        eventoId: '',
      },
      eventos: [],
      eventoId: '',
      eventoIdAtual: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR NOVO DIVULGADOR ' : 'EDITAR DIVULGADOR'
      }
    }),

    mounted() {
      this.carregaDados()
    },

    watch: {
      
    },

    methods: {
      async carregaDados() {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Eventos?filter={"where":{"and":[{"empresaId":"'+this.companyobj.id+'"}]}}&access_token=' + sessionStorage.getItem('accToken')).then(response => {
          if (response.data) {
            for (var key in response.data) {
              if (response.data.hasOwnProperty(key)) {
                this.eventos.push(response.data[key])
              }
            }
            this.eventos = this.eventos.sort(this.compare)
            this.eventoId = this.eventos[0].id
            if (this.eventoIdAtual != '')
              this.eventoId = this.eventoIdAtual
          } else {
            this.isLoading = false
          }
        })
        await this.carregaDivulgadores()
      },

      async carregaDivulgadores() {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Divulgadores?filter={"where":{"eventoId":"'+this.eventoId+'"}}&access_token=' + sessionStorage.getItem('accToken')).then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.isLoading = false
          } else {
            this.isLoading = false
          }
        })
      },

      criarNovo() {
        this.adicionarDivulgador = true
        this.addUser = true
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()
        let comparison = 0;
        if (dataC >= dataA) {
          comparison = 1;
        } else if (dataC < dataA) {
          comparison = -1;
        }
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.adicionarDivulgador = true
        this.addUser = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir o divulgador: ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}Divulgadores/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaDados()
          })
        }
      },

      close() {
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save() {
        this.isLoading = true
        var vm = this;
        if (this.editedIndex != -1) {
          if (this.editedItem.nome || this.editedItem.cpf || this.editedItem.email || this.editedItem.celular || this.editedItem.ativo) {
            await axios.patch(`${baseApiUrl}Divulgadores/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            .then(response => {
              if (response.data != null) {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
                this.carregaDados()
                this.close()
              }
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Preencha todos os campos!", "INFORMAÇÃO")
          }
        } else {
          if (this.editedItem.nome || this.editedItem.cpf || this.editedItem.email || this.editedItem.celular || this.editedItem.ativo) {
            this.editedItem.empresaId = this.companyobj.id
            this.editedItem.eventoId = this.eventoId
            await axios.post(`${baseApiUrl}Divulgadores/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            .then(response => {
              if (response.data != null) {
                vm.$refs.chamaSnackbar.snack("#0288D1", "Divulgador cadastrado com sucesso!", "INFORMAÇÃO")
                this.carregaDados()
                this.close()
              }
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar divulgador, tente novamente", "ERRO")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Preencha todos os campos!", "INFORMAÇÃO")
          }
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>